import { AxiosInstance } from 'axios';
import { ApiModule } from '~/clientApi/ApiModule';

const MODULE = 'v1/status';

const status = (apiInstance: AxiosInstance) =>
  new ApiModule(apiInstance, MODULE, undefined);

export default status;
